
import SHA256 from 'crypto-js/sha256'
import hmacSHA512 from 'crypto-js/hmac-sha512'
import CryptoBase64 from 'crypto-js/enc-base64'

export default {
  methods: {
    hash (message) {
      return CryptoBase64.stringify(hmacSHA512(SHA256(message), this.$store.state.UUID))
    },
  },
}
